import {SOPostView} from '../../core/view/so-post-view';
import {ViewCore} from './view.core';
import {SOGetView} from '../../core/view/so-get-view';
import {FormField, SelectionOption} from 'lionheartland';
import {postViewFormFieldOptions} from './post-view-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';

export class RAPostView extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postViewFormFieldOptions);

  RequestClass = SOPostView

  constructor(
    public entityCore: ViewCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('identifier'),
      this.getFormValueFromIdentifier('type'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}